module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAGAgMAAADMNjS4AAAAAXNSR0IB2cksfwAAAAlQTFRFAAAAUWnMUmrLEJQU2wAAAAN0Uk5TAP+AhOq6jAAAABtJREFUeJxjCIWBMAY4MwLBTEAwGxgQShkQSgGToBOBkSpMkAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/1@2x.png
// module id = /XTv
// module chunks = 1